import { ERequestType } from "generated/graphql";

export const CSS_COLOR_VARS = {
  primary: "var(--paps-ops-color-primary)",
  secondary: "var(--paps-ops-color-secondary)",
  backgroundDangerLight: "var(--red-light-500)",
  backgroundDanger: "var(--red)",
  backgroundPrimary: "var(--light)",
  backgroundSuccessDark: "var(--green)",
  iconNeutral: "var(--paps-ops-color-grayCool)",
  iconFocus: "var(--paps-ops-color-secondaryText)",
  iconCurrent: "var(--paps-ops-color-primary)",
  textPrimary: "var(--dark)",
  textSecondary: "var(--dark-800)",
  textLight: "var(--light)",
  textDangerDark: "var(--red-dark-700)",
  textGrayedIn: "var(--paps-ops-color-textGrayedIn)",
  textGrayedOut: "var(--paps-ops-color-textGrayedOut)",
  textDisabled: "var(--paps-ops-color-textDisabled)",
  greenLight: "var(--paps-ops-color-greenLight)",
  greenFocus: "var(--paps-ops-color-greenFocus)",
};

export const STATUS_COLORS = {
  TO_PICK: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(58, 158, 173, 0.4)",
  },
  PICKUP: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(58, 158, 173, 0.4)",
  },
  TO_RECEIVE: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(57, 158, 191, 0.2)",
  },
  PICKED: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(57, 158, 191, 0.2)",
  },
  UNASSIGNED: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(57, 158, 191, 0.2)",
  },
  AWAITING_DELIVERY: {
    text: "#3981bf",
    bg: "rgba(57, 129, 191, 0.35)",
  },
  DELIVERY_RETURN: {
    text: "#fff",
    bg: "#f35473",
  },
  TO_RETURN: {
    text: "#fff",
    bg: "#f35473",
  },
  NOT_RECEIVED: {
    text: "#f93333",
    bg: "rgba(249, 51, 51, 0.29)",
  },
  TO_BE_ASSIGNED: {
    text: "#399ebf;",
    bg: "rgba(57, 158, 191, 0.2)",
  },
  ASSIGNED: {
    text: "#399ebf;",
    bg: "rgba(57, 158, 191, 0.2)",
  },
  R_TO_BE_ASSIGNED: {
    text: "#399ebf;",
    bg: "rgba(57, 158, 191, 0.2)",
  },
  RETURNED: {
    text: "#fff",
    bg: "#f93333",
  },
  ON_RETURN: {
    text: "#fff;",
    bg: "#ff6666",
  },
  ON_DELIVERY: {
    text: "#124495",
    bg: "rgba(18, 68, 149, 0.17)",
  },
  DELIVERY: {
    text: "#124495",
    bg: "rgba(18, 68, 149, 0.17)",
  },
  COMPLETED: {
    text: "#fff",
    bg: "#39bf86",
  },
  DONE: {
    text: "#fff",
    bg: "#39bf86",
  },
  PARTIALLY_COMPLETED: {
    text: "#279D6B",
    bg: "#A6F7D8",
  },
  PARTIALLY_RECEIVED: {
    text: "#399EBF",
    bg: "#E1EAEF",
  },
  TO_HAND_OVER: {
    text: "#7041c7",
    bg: "rgba(166, 126, 240, 0.53)",
  },
  MONEY_TO_COLLECT: {
    text: "#fff",
    bg: "rgba(243, 133, 84, 0.71)",
  },
  TO_RECONCILE: {
    text: "#fff",
    bg: "#f7d451",
  },

  R_TO_HAND_OVER: {
    text: "#7041c7",
    bg: "rgba(166, 126, 240, 0.53)",
  },
  TO_VALIDATE: {
    text: "#fff",
    bg: "#39bf86",
  },
  NOT_RETURNED: {
    text: "#f93333",
    bg: "rgba(249, 51, 51, 0.29)",
  },
  FAILED: {
    text: "#fff",
    bg: "#f93333",
  },
  SUCCESSFULL: {
    text: "#fff",
    bg: "#39bf86",
  },
  SUCCESSFUL: {
    text: "#fff",
    bg: "#39bf86",
  },
  CANCELLED: {
    text: "#fff",
    bg: "#ff6666",
  },
  undefined: {
    text: "#6b0202",
    bg: "#ffe0e0",
  },
  TO_RESCHEDULE: {
    text: "#fff",
    bg: "#E75314",
  },
  ARCHIVED: {
    text: "#fff",
    bg: "#E75314",
  },
  DELIVERED: {
    text: "#0d8f7e",
    bg: "rgba(57, 191, 134, 0.3)",
  },
  SENT_BACK: {
    text: "#f93333",
    bg: "rgba(249, 51, 51, 0.3)",
  },
  PICK_FAILED: {
    text: "#f93333",
    bg: "#fff",
    border: "#f93333",
  },
  TO_COLLECTE: {
    text: CSS_COLOR_VARS.primary,
    bg: "rgba(57, 158, 191, 0.2)",
  },
  NOT_COLLECTED: {
    text: "#1f1f1f",
    bg: "#f9333380",
  },
  TO_PREPARE: {
    text: "#808080",
    bg: "rgb(238, 238, 238)",
  },
};

export const COLORS = {
  primary: "#399ebf",
  orange: "#F2994A",
  gray: "#7e7f84",
  white: "#fff",
  lightBlue: "#E2F4FB",
  darkGray: "#707070",
  accent: "#f2994a",
  secondary: "#1a224b",
  redLight: "#EB5757",
};
export interface PrinterStatusArgs {
  status: string;
  type: "text" | "bg" | "border";
}
// that help to resolve the crashing screen when a status is added or removed.
export const statusColorPrinter = ({ status = "undefined", type = "text" }: PrinterStatusArgs) => {
  const result = STATUS_COLORS[status];
  status = typeof result === "object" ? status : result;
  return STATUS_COLORS[status][type];
};

export const REQUEST_COLORS = {
  MAD: {
    text: "#394fbf",
  },
  NT: {
    text: "#394fbf",
  },
  TR: {
    text: "#259940",
  },
  Msg: {
    text: "#394fbf",
  },
};

export interface PrinterRequestArgs {
  requestType: string;
  type?: "text";
}

export const requestColorPrinter = ({ requestType = "undefined", type = "text" }: PrinterRequestArgs) => {
  const result = REQUEST_COLORS[requestType];
  requestType = typeof result === "object" ? requestType : result;
  return REQUEST_COLORS[requestType][type];
};

export const MISSION_COLORS = {
  accent: "#f2994a",
  accentDark: "rgb(216, 119, 33)",
  [ERequestType.Nt]: {
    primary: "#394fbf",
    secondary: "rgba(57, 79, 191, 0.24)",
    light: "rgba(57, 79, 191, 0.12)",
  },
  [ERequestType.Mad]: {
    primary: "#2f80ed",
    secondary: "rgba(47, 128, 237, 0.24)",
    light: "rgba(47, 128, 237, 0.12)",
  },
  [ERequestType.Tr]: {
    primary: "#2ba815",
    secondary: "rgba(43, 168, 21, 0.24)",
    light: "rgba(43, 168, 21, 0.12)",
  },
  [ERequestType.Msg]: {
    primary: "#399ebf",
    secondary: "rgba(64, 180, 229, 0.15)",
    light: "rgba(57, 158, 191, 0.06)",
  },
};
